import { Text } from '@wix/design-system';
import React from 'react';
import { useIsStudioNewUi } from '../../hooks/useIsStudioNewUi';
import s from './DisclaimerText.scss';
export const DisclaimerText = _ref => {
  let {
    children
  } = _ref;
  const isStudioNewUi = useIsStudioNewUi();
  return /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true,
    inline: true,
    className: isStudioNewUi ? s.newUi : undefined
  }, children);
};
//# sourceMappingURL=DisclaimerText.js.map